<script setup>
import HorizontalCustomersMenu from '@/components/Menus/Customers/HorizontalCustomersMenu.vue'

definePage({ meta: { ...PageMeta.Customers.preview.meta, pageTitle: 'Customer' } })

import { useRoute } from 'vue-router'
import { useEntityPageTitle } from '@/composables/useEntityPageTitle'
import CustomerPreviewPage from '@/views/apps/customers/preview/CustomerPreviewPage.vue'
import { useCustomersStore } from '@/@vxapp/Customers/useCustomersStore'

const route = useRoute()
const customersStore = useCustomersStore()

useEntityPageTitle({
  entityName: 'Customer',
  record: () => customersStore.customer,
  recordGuid: customer => customer.clientGUID,
  identifier: customer => customer.displayName,
})

/* ** */
</script>

<template>
  <section>
    <!-- Horizontal Menu / Navigation -->
    <VRow>
      <VCol cols="12">
        <HorizontalCustomersMenu :customer-g-u-i-d="route.params.guid" />
      </VCol>
    </VRow>

    <!-- Page -->
    <VRow>
      <VCol cols="12">
        <CustomerPreviewPage :customer-g-u-i-d="route.params.guid" />
      </VCol>
    </VRow>
  </section>
</template>
